exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-d8571728]{max-width:800px}.card .card-content *[data-v-d8571728]{color:#333}button[data-v-d8571728]{color:#fff!important;font-size:1.2rem}.consents[data-v-d8571728] label{font-weight:700}", ""]);

// exports
